var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "image-onboarding-pretest-container d-flex",
    class: {
      'diff-position-images': _vm.sizeImages.width === _vm.SIZE_FOR_MOBILE,
      'diff-position-images-se': _vm.sizeImages.width === _vm.SIZE_FOR_SE_MOBILE
    }
  }, [_c('FirstStepPretestComponent', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStepIndex === _vm.enumSteps.FIRST,
      expression: "currentStepIndex === enumSteps.FIRST"
    }],
    attrs: {
      "size": _vm.sizeImages
    }
  }), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.sizeImages.width === _vm.SIZE_FOR_SE_MOBILE && _vm.currentStepIndex == _vm.enumSteps.FIRST,
      expression: "sizeImages.width === SIZE_FOR_SE_MOBILE && currentStepIndex == enumSteps.FIRST"
    }],
    staticClass: "heading primary--text heading-m-small onboarding-title-regular-mobile pr-6 text-center"
  }, [_vm._v(" " + _vm._s(_vm.titleForMobileSE) + " ")]), _c('SecondStepPretestComponent', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStepIndex === _vm.enumSteps.SECOND,
      expression: "currentStepIndex === enumSteps.SECOND"
    }],
    attrs: {
      "size": _vm.sizeImages
    }
  }), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.sizeImages.width === _vm.SIZE_FOR_SE_MOBILE && _vm.currentStepIndex == _vm.enumSteps.SECOND,
      expression: "sizeImages.width === SIZE_FOR_SE_MOBILE && currentStepIndex == enumSteps.SECOND"
    }],
    staticClass: "heading primary--text heading-m-small onboarding-title-regular-mobile pl-2 pr-3 text-left"
  }, [_vm._v(" " + _vm._s(_vm.titleForMobileSE) + " ")]), _c('ResultStepPretestComponent', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.currentStepIndex === _vm.enumSteps.THIRD,
      expression: "currentStepIndex === enumSteps.THIRD"
    }],
    attrs: {
      "size": _vm.sizeImages
    }
  }), _c('h3', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.sizeImages.width === _vm.SIZE_FOR_SE_MOBILE && _vm.currentStepIndex === _vm.enumSteps.THIRD,
      expression: "sizeImages.width === SIZE_FOR_SE_MOBILE && currentStepIndex === enumSteps.THIRD"
    }],
    staticClass: "heading primary--text heading-m-small onboarding-title-regular-mobile pl-2 pr-3 text-left"
  }, [_vm._v(" " + _vm._s(_vm.titleForMobileSE) + " ")])], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }